import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formCom, control } from '../enum';
import { rules as _rules } from '../rule';
console.log(control);
export default {
  props: {
    formData: {
      default: ''
    },
    isViewCtrl: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formCom: formCom
    };
  },
  computed: {
    rules: function rules(vm) {
      var form = vm.formData.attribute;
      var result = {};
      if (!form) return result;
      var keys = Object.keys(form);
      keys.forEach(function (item) {
        if (_rules[item]) result[item] = _rules[item];
      });
      return result;
    },
    // 组件名称
    title: function title(vm) {
      var type = vm.formData.type;
      var title = '';
      control.forEach(function (item) {
        if (title) return false;
        var result = item.list.filter(function (el) {
          return el.type === type;
        });
        if (result && result[0]) title = result[0].name;
      });
      return vm.$t(title);
    }
  }
};